// extracted by mini-css-extract-plugin
export default {"myTabs":"tabs_myTabs__-+PkN","badge":"tabs_badge__Uc6w6","badge-yellow":"tabs_badge-yellow__I0Aoa","badge-green":"tabs_badge-green__oAMYi","badge-red":"tabs_badge-red__y9iZp"};